<template>
  <div class="tour-categories font-text">
    <a
      v-for="{ code, name } in categories"
      :key="code"
      :href="`/tours/type/${code}`"
      target="_blank"
      class="tour-categories__item"
    >
      {{ name }}
    </a>
  </div>
</template>

<script>
export default {
  props: {
    categories: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.tour-categories {
  display: flex;
  flex-wrap: wrap;
  margin: -8px -4px 0;
  margin-top:45px;

  &__item {
    border: 1px solid var.$gray-dark;
    color: var.$secondary;
    border-radius: 50px;
    padding: 7.5px 12px;
    margin: 8px 4px 0;
    &:hover {
      background: var.$gray-pale;
    }
  }
}
</style>
